import { formatDictAsHtml } from '@app/common/helpers/formatDictAsHtml'
import { CustomerDocument } from '@app/graphql/types'
import { formatUtilityBillMetaDataAsHtml } from '@app/modules/Messages/Components/Question/helpers/formatUtilityBillMetaDataAsHtml'
import { Customer, Message as CustomerMessageType } from '@app/queries/CustomerAsLawyer/models'

export const enrichMessageContent = ({
  customer,
  message
}: {
  customer: Customer
  message: CustomerMessageType
}) => {
  if (!message.approvedAt) {
    return message
  }

  const messageHasQuestionnaire =
    !!message.topicQuestionnaireAnswers &&
    Object.keys(message.topicQuestionnaireAnswers).length !== 0

  const questionnaireHTML = messageHasQuestionnaire
    ? `${formatDictAsHtml(message.topicQuestionnaireAnswers)}`
    : ''

  const documentsMetaDataInitialValue = messageHasQuestionnaire ? '<br/><br/>' : ''

  const documentsMetaData = message.documents?.reduce(
    (accumulator, currentValue: CustomerDocument) => {
      if (!currentValue.metadata) {
        return accumulator
      }

      for (const metaDataPropName in currentValue.metadata) {
        const noMetaData = !currentValue.metadata![metaDataPropName]
        if (metaDataPropName === '__typename' || noMetaData) {
          continue
        }

        if (metaDataPropName === 'utilityBillCheck' && !!currentValue.metadata![metaDataPropName]) {
          accumulator =
            accumulator +
            `${formatUtilityBillMetaDataAsHtml(currentValue.metadata![metaDataPropName]!)}`
        }
      }

      return accumulator
    },
    documentsMetaDataInitialValue
  )

  const enrichedContent = `${questionnaireHTML}${documentsMetaData}${message.content}`

  const enrichedMessage = {
    ...message,
    content: enrichedContent,
    appointmentAt: message.appointmentAt && new Date(message.appointmentAt),
    customer
  }

  return enrichedMessage
}
